/**
 * SF-4770: "Open in web app" for one company. sf-api builds the address (`web_app_link`, the web
 * app with `?open_company=<id>`), so this app never needs to know the web app's host. The web app
 * opens that company for a super admin who can see it, or opens as normal.
 */
export const WebAppLink: React.FC<{
  href: string;
  /** SF-4848: the link text where "Open in web app" alone is unclear (the demo page). */
  label?: string;
}> = ({ href, label = 'Open in web app' }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid="web-app-link">
    {label}
  </a>
);
